var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJpgSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.34167 4C4.34167 1.79086 6.13254 0 8.34167 0H24.3417L36.3417 12V36C36.3417 38.2091 34.5508 40 32.3417 40H8.34167C6.13254 40 4.34167 38.2091 4.34167 36V4Z",
    fill: "#7F56D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M24.3417 0L36.3417 12H28.3417C26.1325 12 24.3417 10.2091 24.3417 8V0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1327 30.2686H13.2357C13.2489 30.7915 13.6093 31.1431 14.1366 31.1431C14.743 31.1431 15.0726 30.7739 15.0726 30.0884V25.6587H16.202V30.0972C16.202 31.3892 15.4374 32.1362 14.1498 32.1362C12.9413 32.1362 12.1327 31.3936 12.1327 30.2686ZM17.3534 25.6587H19.8187C21.08 25.6587 21.9545 26.5156 21.9545 27.7812C21.9545 29.0469 21.0536 29.9038 19.7704 29.9038H18.4872V32H17.3534V25.6587ZM18.4872 26.5859V28.9897H19.5155C20.3285 28.9897 20.8031 28.5503 20.8031 27.7812C20.8031 27.021 20.3329 26.5859 19.5199 26.5859H18.4872ZM28.3353 29.3545C28.3353 31.0728 27.307 32.1055 25.5712 32.1055C23.7211 32.1055 22.5697 30.8486 22.5697 28.8052C22.5697 26.7925 23.7167 25.5532 25.5492 25.5532C26.9906 25.5532 28.0804 26.4058 28.287 27.6758H27.1356C26.9203 26.9463 26.3314 26.5156 25.5536 26.5156C24.411 26.5156 23.7299 27.3638 23.7299 28.792C23.7299 30.251 24.4418 31.1431 25.5844 31.1431C26.5424 31.1431 27.2059 30.5366 27.2235 29.6489L27.2279 29.5435H25.6986V28.6777H28.3353V29.3545Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJpgSvg);
export default __webpack_public_path__ + "static/media/jpgSvg.25ac3b883500e83cb1eb224ee387fb12.svg";
export { ForwardRef as ReactComponent };